export default function MemberDetailRow({ label, value }) {
    return (
        <div className="flex flex-col">
            <label className="text-xs text-gray-500">
                {label}
            </label>
            <span className="text-gray-800 font-medium">
                {value}
            </span>
        </div>
    );
}